import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';

export default class extends React.Component {
    static propTypes = {
        vendorName: React.PropTypes.string.isRequired,
        onClose: React.PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            show: true,
        };
    }

    handleClose = (e) => {
        e.preventDefault();
        this.setState({ show: false }, () => {
            this.props.onClose();
        });
    };

    render() {
        return (
            <Modal show={this.state.show}
                   dialogClassName="alt-theme vendor-event-modal"
                   bsSize="large"> <Modal.Header> What to Expect Next </Modal.Header>

                <div className="modal-body">
                    Thanks for your submission. You should expect to hear back from {this.props.vendorName} within 24 hours.
                </div>

                <Modal.Footer>
                    <a className="btn btn-default" onClick={this.handleClose}>Close</a>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/user/VendorEventModal.jsx